import { render } from "./myActivitiesDeatil.vue?vue&type=template&id=c5a1f524&scoped=true"
import script from "./myActivitiesDeatil.vue?vue&type=script&lang=js"
export * from "./myActivitiesDeatil.vue?vue&type=script&lang=js"

import "./myActivitiesDeatil.vue?vue&type=style&index=0&id=c5a1f524&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a1f524"]])

export default __exports__